import { isHex } from 'viem';
import { z } from 'zod';
import { PaymasterErrorCode } from '../../../types';
export const zHex = z.custom((val) => typeof val === 'string' && isHex(val));
// Create Zod schemas based on the TypeScript types
const zPaymaster06Response = z.object({
    paymasterAndData: zHex,
    preVerificationGas: zHex,
    verificationGasLimit: zHex,
    callGasLimit: zHex,
    maxPriorityFeePerGas: zHex.optional(),
    maxFeePerGas: zHex.optional(),
});
const zPaymaster07Response = z.object({
    preVerificationGas: zHex,
    callGasLimit: zHex,
    paymasterVerificationGasLimit: zHex,
    paymasterPostOpGasLimit: zHex,
    verificationGasLimit: zHex,
    paymaster: zHex,
    paymasterData: zHex,
    maxPriorityFeePerGas: zHex.optional(),
    maxFeePerGas: zHex.optional(),
});
export const paymasterDataSchema = z.object({
    data: z.union([zPaymaster06Response, zPaymaster07Response]),
});
export const paymasterErrorSchema = z.object({
    errorDetail: z.object({
        code: z.nativeEnum(PaymasterErrorCode),
    }),
});
export const tokenQuoteSchema = z.object({
    data: z.object({
        estimate: z.string(),
        decimals: z.number(),
    }),
});
